import axios from 'axios'
import { GET_USER_SUCCESS, GET_USER_ERROR, GET_USER_BADGE_SUCCESS, GET_USER_BADGE_ERROR } from './constants'

export const getUser = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({
    ...data,
    state: 'submitting',
  }))
  const { email } = formObj
  const config = {
    headers: { 'Content-Type': 'application/json' },
  }
  const body = JSON.stringify({ email })
  try {
    let res = await axios.post(`${process.env.REACT_APP_API_URI}/xcb/api/user`, body, config)
    dispatch({
      type: GET_USER_SUCCESS,
      payload: res.data.content,
    })
  } catch (err) {
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: GET_USER_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: GET_USER_ERROR, payload: errResp.data.errors })
  } finally {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
    }))
  }
}

export const getUserBadge = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({
    ...data,
    state: 'submitting',
  }))
  const { email, title, version } = formObj
  const config = {
    headers: { 'Content-Type': 'application/json' },
  }
  const body = JSON.stringify({ email, title, version })
  try {
    let res = await axios.post(`${process.env.REACT_APP_API_URI}/xcb/api/user/badge`, body, config)
    dispatch({
      type: GET_USER_BADGE_SUCCESS,
      payload: res.data.content,
    })
  } catch (err) {
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: GET_USER_BADGE_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: GET_USER_BADGE_ERROR, payload: errResp.data.errors })
  } finally {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
    }))
  }
}
